'use strict';

app.controller('MessagesCtrl', [
    '$scope',
    '$http',
    '$translate',
    '$ngConfirm',
    'toaster',
    function($scope, $http, $translate, $ngConfirm, toaster) {
        $scope.LIST_TAB = 1;
        $scope.PREVIEW_TAB = 2;
        $scope.tab = $scope.LIST_TAB;

        $scope.colors = [
            { text: 'blue', value: '0' },
            { text: 'green', value: '1' },
            { text: 'yellow', value: '2' },
            { text: 'red', value: '3' },
        ];

        $scope.form = {
            message: '',
            color: 0,
            dates: {
                start: moment.utc().startOf('day'),
                end: moment.utc().endOf('day'),
            },
        };

        $scope.messages = [];
        $scope.loading = false;
        $scope.expanded = false;
        $scope.editModeEntry = false;
        $scope.initialForm = angular.copy($scope.form);

        $scope.isTab = function(tab) {
            return $scope.tab === tab;
        };

        var resetForm = function() {
            $scope.form = angular.copy($scope.initialForm);
        };

        var afterFormAction = function() {
            resetForm();

            $scope.list();
            $scope.isExpandedForm() && $scope.toggleExpandedForm();
            $scope.editModeEntry = false;
        };

        $scope.toggleExpandedForm = function() {
            $scope.expanded = !$scope.expanded;
        };

        $scope.isExpandedForm = function() {
            return $scope.expanded === true;
        };

        $scope.isInEditMode = function() {
            return $scope.editModeEntry;
        };

        $scope.isMessageInEditMode = function(message) {
            return $scope.isInEditMode() && $scope.editModeEntry.id === message.id;
        };

        $scope.goToEditMode = function(message) {
            $scope.editModeEntry = prepareEditModeEntry(message);
            $scope.form = angular.copy($scope.editModeEntry);
            $scope.expanded = true;
        };

        var prepareEditModeEntry = function(message) {
            return {
                id: message.id,
                color: message.color,
                message: message.message,
                title: message.title,
                dates: {
                    start: message.dateStart,
                    end: message.dateEnd,
                },
            };
        };

        $scope.cancelEditMode = function() {
            $scope.editModeEntry = false;
            $scope.expanded = false;
        };

        var validate = function(payload) {
            if (payload.message === '') {
                return false;
            }

            return true;
        };

        var buildPayload = function(payload) {
            return {
                message: payload.message,
                title: payload.title,
                color: payload.color,
                dateStart: payload.dates.start,
                dateEnd: payload.dates.end,
            };
        };

        $scope.create = function() {
            var payload = buildPayload($scope.form);

            if (!validate(payload)) {
                toaster.pop(
                    'error',
                    $translate.instant('general.toastr.error.header'),
                    $translate.instant('general.toastr.error.form.validation.fill')
                );

                return false;
            }

            $http.post('/api/message', payload).then(
                function() {
                    toaster.pop(
                        'success',
                        $translate.instant('general.toastr.success.header'),
                        $translate.instant('general.toastr.success.form.action.save')
                    );

                    afterFormAction();
                },
                function() {
                    toaster.pop(
                        'error',
                        $translate.instant('general.toastr.error.header'),
                        $translate.instant('general.toastr.error.form.action.save')
                    );
                }
            );

            return true;
        };

        $scope.update = function() {
            var payload = buildPayload($scope.form);

            if (!validate(payload)) {
                toaster.pop(
                    'error',
                    $translate.instant('general.toastr.error.header'),
                    $translate.instant('general.toastr.error.form.validation.fill')
                );

                return false;
            }

            $http.put('/api/message/' + $scope.form.id, payload).then(
                function() {
                    toaster.pop(
                        'success',
                        $translate.instant('general.toastr.success.header'),
                        $translate.instant('general.toastr.success.form.action.update')
                    );

                    afterFormAction();
                },
                function() {
                    toaster.pop(
                        'error',
                        $translate.instant('general.toastr.error.header'),
                        $translate.instant('general.toastr.error.form.action.update')
                    );
                }
            );

            return true;
        };

        $scope.delete = function(id) {
            $http.delete('/api/message/' + id).then(
                function() {
                    toaster.pop(
                        'success',
                        $translate.instant('general.toastr.success.header'),
                        $translate.instant('general.toastr.success.form.action.delete')
                    );

                    $scope.list();
                },
                function() {
                    toaster.pop(
                        'error',
                        $translate.instant('general.toastr.error.header'),
                        $translate.instant('general.toastr.error.form.action.delete')
                    );
                }
            );

            return true;
        };

        $scope.list = function() {
            $scope.loading = true;
            $scope.messages = [];

            $http.get('/api/message/list').then(
                function(response) {
                    var messages = response.data.data || {};
                    $scope.messages = messages !== void 0 ? messages : [];

                    $scope.loading = false;
                },
                function() {
                    $scope.loading = false;
                }
            );
        };

        $scope.init = function() {
            $scope.list();
        };

        $scope.deleteConfirmation = function(message) {
            $ngConfirm({
                title: $translate.instant('general.confirm.delete.title'),
                content: $translate.instant('general.confirm.delete.content'),
                animation: 'rotate',
                theme: 'supervan',
                columnClass: 'medium',
                icon: 'pe-7s-trash pe-lg pe-va',
                scope: $scope,
                buttons: {
                    yes: {
                        text: $translate.instant('general.confirm.delete.yes'),
                        btnClass: 'btn-danger',
                        action: function(scope) {
                            scope.delete(message.id);

                            return true;
                        },
                    },
                    no: {
                        text: $translate.instant('general.confirm.delete.no'),
                        btnClass: 'btn-dark',
                    },
                },
            });
        };

        $scope.init();
    },
]);

app.controller('ShowAppMessagesCtrl', [
    '$scope',
    '$http',
    '$interval',
    '$localStorage',
    'toaster',
    function($scope, $http, $interval, $localStorage, toaster) {
        var REFRESH_TIME_IN_MILISECONDS = 300000;

        var messagesToShowIds = [];
        var messagesAlreadyShowed = [];

        var getMessages = function() {
            $http.get('/api/message/show', { displayButterbar: false }).then(function(response) {
                var messages = response.data.data || [];

                if (messages.length > 0) {
                    filterNotSeenMessages(messages);

                    if (messagesToShowIds.length > 0) {
                        showAppMessage(messages);
                    }
                }
            });

            return true;
        };

        var filterNotSeenMessages = function(messages) {
            var ids = messages.map(function(message) {
                return message.id;
            });

            messagesToShowIds = ids.filter(function(id) {
                return !$localStorage.seenMessagesIds.includes(id);
            });
        };

        var colorsMapper = {
            info: 'info',
            success: 'success',
            warning: 'warning',
            danger: 'error',
        };

        var showAppMessage = function(messages) {
            messages.forEach(function(message) {
                if (!messagesToShowIds.includes(message.id) || messagesAlreadyShowed.includes(message.id)) {
                    return;
                }

                toaster.pop({
                    type: colorsMapper[message.color],
                    title: message.title,
                    body: message.message,
                    toasterId: 2,
                    showCloseButton: true,
                    timeout: 0,
                    onShowCallback: function() {
                        messagesAlreadyShowed.push(message.id);
                    },
                    onHideCallback: function() {
                        $localStorage.seenMessagesIds.push(message.id);
                    },
                });
            });
        };

        $scope.init = function() {
            if ($localStorage.seenMessagesIds === undefined) {
                $localStorage.seenMessagesIds = [];
            }

            getMessages();

            $interval(function() {
                getMessages();
            }, REFRESH_TIME_IN_MILISECONDS);
        };

        $scope.init();
    },
]);

app.controller('ShowPuescMessagesCtrl', [
    '$scope',
    '$http',
    '$timeout',
    '$translate',
    'toaster',
    function($scope, $http, $timeout, $translate, toaster) {
        var REFRESH_TIME_IN_MILISECONDS = 600000;
        var timeout = null;

        var isMessageShown = false;

        var getExternalSystemDown = function() {
            $timeout.cancel(timeout);
            timeout = $timeout(getExternalSystemDown, REFRESH_TIME_IN_MILISECONDS);

            if (isMessageShown) {
                return false;
            }

            return $http
                .get('/rest-api/ms/puesc/api/notification/down/sent', { displayButterbar: false })
                .then(function(response) {
                    var result = false;

                    if (response.status) {
                        if (typeof response.data === 'boolean') {
                            result = response.data;
                        }
                    }

                    if (result === true) {
                        isMessageShown = true;

                        toaster.error({
                            title: $translate.instant('puesc.notification.title'),
                            body: $translate.instant('puesc.notification.body'),
                            toasterId: 3,
                            showCloseButton: true,
                            timeout: 0,
                        });
                    }
                })
                .catch(function() {});
        };

        $scope.init = function() {
            getExternalSystemDown();
        };

        $scope.$on('$destroy', function() {
            $timeout.cancel(timeout);
        });

        $scope.init();
    },
]);
